import React, { useEffect, useState, useRef, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {connect,  useDispatch, useSelector } from 'react-redux';
import { stageActions, content_groupActions, assigned_userActions, alertActions, contentLabelActions, work_spaceActions } from '../../../actions';
import { Button, Row, Col, Dropdown, ButtonGroup, Image } from 'react-bootstrap';
import {
  Popup,
  BasicSpinner,
  StageInlineEdit,
  DateTimeInlineEdit,
  StageLabel,
  EditStageDropdown,
  PerPageContentGroup,
  ElementTooltip,
  CardTag,
  ProgressIcon,
  StopWatch,
  UserThumbnails,
  RedDot
} from '../../../components';
import NewContentGroupSingleFieldForm from './newSingleFieldForm';
import { CircleAddIcon } from "../../../components";
import DragIcon from "../../../images/icons/drag.svg";
import LoadiGif from "../../../images/loading_image.gif";
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { useMediaQuery } from 'react-responsive'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ParticipantField from "./sections/participantField";
import LabelField from "./sections/labelField";
import { useIsVisible } from '../../../utils/useIsVisible';
import { WorkspaceShowContext } from "../../../contexts/WorkspaceShowContext";
import { dateTimeFormatter } from "../../../utils/";
import { tooltipConstants, mediaQueryConstants, userConstants } from "../../../constants/";
import { hasDraft } from '../../../utils/isDraftHasValue';
import { DraftCommentIcon } from '../../../components';
import { formatDisplay } from '../../../utils/numberFormat';
import { ContentGroupSettings } from '../../../components/content_group_settings';
import { StageCardCount } from '../../../components/stage/StageCardCount';
import { StageSettingsIcon } from '../../../components/stage/StageSettingsIcon';
import { CardSubtaskStats } from '../../../components/content_group/CardSubtaskStats';
import { CardRevisionCount } from '../../../components/content_group/CardRevisionCount';
import { CardTimerStats } from '../../../components/content_group/CardTimerStats';
import { stageConstants } from '../../../constants/stage.constants';
import useIsCardVisited from '../../../hooks/useIsCardVisited';

function ContentGroupList(props) {
  const isLargeScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.LARGE}px)` })
  const dispatch = useDispatch();
  const {
    index,
    rows,
    stage_id,
    workspace_id,
    stage,
    stage_name,
    can_access_edit_title,
    can_access_assigned_user,
    can_access_move_content_list,
    can_access_show_content_details,
    can_access_add_change_date,
    handleInlineEdit,
    can_access_approval_dots,
    can_access_edit_label,
    allowed_stages,
    can_access_move_stage_board,
    addContentGroupToStage,
    loadNextPage,
    updated_at,
    removeContentGroupToStage,
    currentSearchText,
    updated_content_group,
    can_access_clone_content_group,
    can_access_content_destroy,
    stages_to_reload
  } = props

  const perPage = PerPageContentGroup;
  const [loading, setLoading] = useState(false);
  const [showAddContentGroupField, setShowAddContentGroupField] = useState(false);
  const addContentGroupRowRef = useRef();
  const stageRef = useRef();
  const isVisible = useIsVisible(stageRef);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const loading_ref = useRef(loading);

  const {
    isCardVisited
  } = useIsCardVisited();

  const {
    can_access_stage,
    can_access_content,
    can_access_sort_stage,
    resetStage,
    replaceContentGroupToStage,
    handleSortByDueDateStage,
    handleOpenContentGroupPopUp,
    handleShowDeleteStagePopup,
    refreshContentGroupToStage,
    loadTracker,
    organization_id,
    query
  } = useContext(WorkspaceShowContext);

  const addContentGroups = (result) => {
    const reset_content_group = false;
    addContentGroupToStage(stage, result.content_groups, result.total_pages, result.has_next_page, reset_content_group)
  }

  const resetContentGroup = (result) => {
    const reset_content_group = true;
    addContentGroupToStage(stage, result.content_groups, result.total_pages, result.has_next_page, reset_content_group)
  }


  useEffect(() => {
    if(isVisible && initialLoaded && loadTracker && !loading_ref.current){

      const onSuccess = (response) => {
        dispatch({ type: stageConstants.REFRESH_STAGE, payload: response.data });
      }

      const onError = (response) => { 
        dispatch({ type: userConstants.STAGE_FAILURE, payload: response.data.error});
        dispatch(alertActions.error(response.data.message));
      };

      dispatch(stageActions.refreshListPaginate({
                                                  workspace_id, 
                                                  stage_id, 
                                                  page: 1, 
                                                  per_page: rows?.page * perPage, 
                                                  currentSearchText,
                                                  onSuccess,
                                                  onError
                                                }));
    }
  }, [loadTracker]);

  useEffect(() => {
    loading_ref.current = loading
  }, [loading]);

  useEffect(() => {
    if((isVisible && !initialLoaded && rows?.page === 1) ){
      const search = query.get('search');
      dispatch(stageActions.listPaginate(workspace_id, stage_id, resetContentGroup, setLoading, 1, perPage, search));
      setInitialLoaded(true);
    } else if(isVisible && initialLoaded){
      const onSuccess = (response) => {
        dispatch({ type: stageConstants.REFRESH_STAGE, payload: response.data });
      }

      const onError = (response) => { 
        dispatch({ type: userConstants.STAGE_FAILURE, payload: response.data.error});
        dispatch(alertActions.error(response.data.message));
      };

      dispatch(stageActions.refreshListPaginate({
        workspace_id, 
        stage_id, 
        page: 1, 
        per_page: rows?.page * perPage, 
        currentSearchText, 
        onSuccess, 
        onError
      }));
    }
  }, [isVisible]);

  useEffect(() => {
    const needsToReload = stages_to_reload?.findIndex(s => s.id == stage_id) !== -1;

    if(needsToReload && isVisible){
      const onSuccess = (response) => {
        refreshContentGroupToStage(stage, response.data.content_groups)
      }

      const onError = (response) => { 
        dispatch({ type: userConstants.STAGE_FAILURE, payload: response.data.error});
        dispatch(alertActions.error(response.data.message));
      };

      dispatch(stageActions.refreshListPaginate({
                                                  workspace_id, 
                                                  stage_id, 
                                                  page: 1, 
                                                  per_page: rows?.page * perPage, 
                                                  currentSearchText,
                                                  onSuccess,
                                                  onError
                                                }));
    }
  }, [stages_to_reload]);

  useEffect(() => {
    if(props?.created_content_group && stage_id == props?.created_content_group.stage_id){
      addContentGroupToStage(stage, [props.created_content_group], stage.total_pages)
    }
  }, [props?.created_content_group]);

  useEffect(() => {
    if(props?.destroyed_content_group && stage_id == props?.destroyed_content_group.stage_id){
      removeContentGroupToStage(stage, props.destroyed_content_group)
    }
  }, [props?.destroyed_content_group]);

  /*
    For Pagination
  */
  useEffect(() => {
    if(rows?.page && isVisible && rows?.page > 1){
      dispatch(stageActions.listPaginate(workspace_id, stage_id, addContentGroups, setLoading, rows?.page, perPage, currentSearchText));
    }
  }, [rows?.page]);

  useEffect(() => {
    if(loading_ref.current) return;

    if (currentSearchText !== '' || !isVisible) {
      setInitialLoaded(false)
    } else {
      setInitialLoaded(true)
    }
    if(rows?.page && isVisible){
      resetStage(rows);
      dispatch(stageActions.listPaginate(workspace_id, stage_id, resetContentGroup, setLoading, 1, perPage, currentSearchText));
    }
  }, [currentSearchText]);

  useEffect(() => {
    if (updated_content_group) {
      let current_content_group_index = rows?.items.findIndex(r => r.id === updated_content_group.id)

      if (current_content_group_index !== -1) {
        if (rows?.id != updated_content_group.stage_id) {
          removeContentGroupToStage(rows, updated_content_group)
        } else {
          replaceContentGroupToStage(rows, updated_content_group)
        }
      } else {
        if (rows?.id == updated_content_group.stage_id) {
          addContentGroupToStage(rows, [updated_content_group])
        }
      }
    }
  }, [updated_content_group]);

  /* Filtered Content Group */

  /*
  const [filter, setFilter] = useState(filter_options[0]);
  let filtered_content_groups = []
  let active_content_groups = content_groups && content_groups.length > 0 && content_groups.filter((content_group) => content_group.archived == false);
  let archived_content_groups = content_groups && content_groups.length > 0 && content_groups.filter((content_group) => content_group.archived == true);

  switch(filter){
    case "active":
      filtered_content_groups = active_content_groups;
      break;

    case "archived":
      filtered_content_groups = archived_content_groups;
      break;

    default:
      filtered_content_groups = content_groups;
  }
  */

  const handleInlineStageEdit = (handleOnBlur, values, workspace_id, stage_id) => {
    if(can_access_edit_title) {
      dispatch(stageActions.inlineEditStage(handleOnBlur, values, workspace_id, stage_id));
    }else {
      dispatch(alertActions.error("You are not authorized to access this page"));
    }
  }

  const handleCloseNewForm = () => {
    setShowAddContentGroupField(false);
  };

  const handleCreateContentGroupSuccess = (id) => {
    setShowAddContentGroupField(false)
  };

  const handleNewContentGroupSubmit = (values) => {
    dispatch(content_groupActions.createContentGroup(values, workspace_id, handleCreateContentGroupSuccess));
  }

  const inactiveSearchText = currentSearchText === '' || currentSearchText === null || currentSearchText === undefined;

  const renderItems = useMemo(() => {
    return () => (
      <div className={'d-flex justify-content-between'}>
        <div className="align-self-center position-relative w-100 text-left">
          {can_access_edit_title ?
            <StageInlineEdit
              stage={stage}
              value={stage_name}
              edit_type="name"
              handleInlineEdit={(handleOnBlur, name) => handleInlineStageEdit(handleOnBlur, name, workspace_id, stage_id)}
              inputFocusWidth={180}
            />
          :
            <h2 className="h4 mb-0 w-100" style={{maxWidth: "fit-content"}}>
              { stage_name }
            </h2>
          }
        </div>
        <div className="d-flex align-self-center justify-content-between">
          { can_access_approval_dots &&
            <div className="d-flex align-items-center mx-2">
              <StageSettingsIcon stage={stage} isVisible={can_access_approval_dots}/>
            </div>
          }
          <div className='d-flex align-items-center justify-content-center'>
            <StageCardCount count={stage.content_groups_count} className={'mx-1'}/>
          </div>

          {
            (can_access_stage || can_access_content || can_access_sort_stage) &&
            <EditStageDropdown
              stage={stage}
              inactiveSearchText={inactiveSearchText}
              setShowAddContentGroupField={setShowAddContentGroupField}
              button_style={{ width: 20 }}
            />
          }

        </div>
      </div>
    )
  }, [
    can_access_approval_dots,
    can_access_edit_title,
    stage,
    stage_name,
    workspace_id,
    stage_id,
    can_access_stage,
    can_access_content,
    can_access_sort_stage,
    inactiveSearchText,
    setShowAddContentGroupField
  ]);

  const AddCardButton = () => {
    return (
      <table class='content-group-table content-list-table content-group-footer px-0'>
        
        { rows?.page < rows?.total_pages || (can_access_content && inactiveSearchText) ?
              <>
                {
                  rows?.items?.length > 0 &&
                  <tr className="footer-spacer" />
                }
                
                <tfoot>
                  <tr ref={addContentGroupRowRef}>
                    <td
                      style={{width: 530}}  
                      className={`add-content-column p-0 ${showAddContentGroupField ? ' focused' : 'mb-2'}`}
                    >
                      {
                        can_access_content && inactiveSearchText &&
                        <>
                          { showAddContentGroupField ?
                            <NewContentGroupSingleFieldForm
                              onSubmit={ handleNewContentGroupSubmit }
                              workspace_id={workspace_id}
                              handleClose={ handleCloseNewForm }
                              addContentGroupRowRef={addContentGroupRowRef}
                              handleOpenContentGroupPopUp={ handleOpenContentGroupPopUp }
                              stageId={ stage_id } 
                              buttonAbsolutePositioning={true}
                            />
                          :
                            <Button 
                              className="button-content-add w-100" onClick={() => setShowAddContentGroupField(true)}
                              disabled={loading}
                            >
                              { loading ? 'loading...' : 'Add Card' }
                            </Button>
                        }
                        </>
                      }

                    </td>
                  </tr>
                </tfoot>
              </>
            :
              can_access_content && inactiveSearchText &&
                <>
                  {
                    rows?.items?.length > 0 &&
                    <tr className="footer-spacer" />
                  }
                  
                  <tfoot>
                    <tr ref ={addContentGroupRowRef} className="add-content-column">
                      <td
                        style={{width: 530}}
                          className="add-content-column"
                      >
                        { showAddContentGroupField ?
                          <NewContentGroupSingleFieldForm
                            onSubmit={ handleNewContentGroupSubmit }
                            handleClose={ handleCloseNewForm }
                            addContentGroupRowRef={addContentGroupRowRef}
                            handleOpenContentGroupPopUp={ handleOpenContentGroupPopUp }
                            stageId={ stage_id } 
                            workspace_id={workspace_id}
                            />
                        :
                          <Button
                            variant=""
                            className="button-content-add d-flex align-items-center"
                            onClick={() => setShowAddContentGroupField(true)}
                          >
                            <CircleAddIcon color={"#8D8E9D"} height={'16'} width={'16'} className="mr-2"/>
                            Add Card
                          </Button>
                      }
                    </td>
                    </tr>
                  </tfoot>
                </>
          }
      </table>
    )
  }

  return (
    <div 
      ref={stageRef}
    >
      <Draggable
        draggableId={rows.id.toString()}
        index={index}
        key={rows.id.toString()}
        isDragDisabled={true}
      >
        {(provided, snapshot) => {
          return (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <Droppable
                droppableId={rows.id.toString()}
                key={rows.id}
                type="CARD"
              >
                {(dropProvided, dropSnapshot) => {
                  return (
                    <div
                      className={`stack-table content-group-table_container `}
                      id={isLargeScreen ? "responsive-mobile" : null}
                      ref={dropProvided.innerRef}
                      {...provided.droppableProps}
                    >
                      <table
                        className={`content-group-table table table-light responsive-table content-list-table row-hoverable with-border-spacing body-table content-group-table${ stage?.visible_to_client ? '--visible-to-client' : '' }`}
                        data-stage={JSON.stringify({name: rows?.name, id: rows?.id})}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{width: 530}} scope="col"
                              className='content-group-table__title'
                            >
                              {renderItems()}
                            </th>
                            <th
                              style={{width: 170}}
                              className="content-group-table__stage text-center">
                            </th>
                            <th
                              style={{width: 170}}
                              className="content-group-table__due-date text-center">
                            </th>
                            <th
                              style={{width: 170}}
                              className="content-group-table__label text-center">

                            </th>
                            {can_access_show_content_details &&
                              <th
                                style={{width: 170}}
                                scope="col"
                                className="content-group-table__participants text-center">
                              </th>
                            }
                            <th
                              className="content-group-table__subtask text-center subtask-cell">
                            </th>

                            <th
                              className="content-group-table__timer text-center timer-cell">
                            </th>

                            <th
                              className="content-group-table__revision text-center revision-cell">
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                        { rows?.items?.length > 0 ?
                          rows?.items?.map((data, index) => {
                            const has_unread_comments = data?.unread_comments?.team || data?.unread_comments?.guest;
                            return (
                              <Draggable
                                key={"card-"+data.id}
                                draggableId={"card-"+data.id}
                                index={index}
                                isDragDisabled={can_access_move_content_list ? false : true}>
                                {(dragProvided, dragSnapshot) => {
                                  return (
                                    <tr
                                      className="hovet-tr"
                                      {...dragProvided.draggableProps}
                                      ref={dragProvided.innerRef}
                                    >
                                      <td className="drag-icons-td pivoted ps-0">
                                        <div className={`d-flex align-items-center ${isLargeScreen ? 'h-100' : ''}`}>
                                          <div className={`ps-0 ${isLargeScreen ? 'h-100' : ''}`}>
                                            <div
                                              className={`d-flex align-items-stretch visible_div ${isLargeScreen ? 'h-100' : ''}`}
                                              data-id={data.id}
                                              data-image-pending={data.preview && data.preview.content_attachment && data.preview.content_attachment_type != 'application/pdf' ? 'true' : 'false'}
                                              id={`find_div_${data.id}`}
                                            >

                                              {
                                                  can_access_move_content_list ?
                                                    <div
                                                      className="drag-icons d-flex flex-row"
                                                      {...dragProvided.dragHandleProps}
                                                    >
                                                      <span className='card-index mx-2'>{ formatDisplay(index + 1) }</span>
                                                      <img height="16" src={DragIcon} title="Drag Content" className={'drag-icon-image'} />
                                                    </div>
                                                  :

                                                    <div
                                                      className="drag-icons d-flex flex-row drag-disabled"
                                                    >
                                                      <span className='card-index mx-2'>{ formatDisplay(index + 1) }</span>
                                                    </div>
                                              }
                                              
                                              <div
                                                className="d-flex align-items-center"
                                                
                                              >
                                                {
                                                  data.preview && data.preview.content_attachment &&(
                                                    data.preview.content_attachment_type == "application/pdf" ?
                                                      <i className="content-group-table__icon fa fa-file-pdf-o" aria-hidden="true" style={{fontSize: 35}}></i>
                                                    :
                                                      <img
                                                        src={LoadiGif}
                                                        className="content-group-table__icon content_attachment_img ms-2"
                                                      />
                                                  )
                                                }
                                                <div className="page-content-group-list__content-group-container">

                                                   {
                                                      stage?.enable_timestamp &&
                                                      <div className='d-flex'>
                                                        <UserThumbnails 
                                                          users={data?.timestamp_info?.users}
                                                          openUserSummary={true}
                                                          workspace_id={workspace_id}
                                                          organization_id={organization_id}
                                                          size={'small'}
                                                          className={'mt-2 mb-0 me-3'}
                                                        />
                                                    
                                                        <StopWatch
                                                          initialTime={data.timestamp_info?.latest_change_total_seconds || 0}
                                                          initialStartDate={data.timestamp_info?.latest_start}
                                                          isActive={stage?.enable_timestamp && data.timestamp_info?.active}
                                                          viewMode={'LIST'}
                                                        />
                                                      </div>
                                                      
                                                    }
                                                  <CardTag
                                                    completed={data?.completed}
                                                    due_date={data?.due_date}
                                                    reminder_in_day={data?.reminder_in_day}
                                                    can_access_content={can_access_content}
                                                    workspace_id={workspace_id}
                                                    card_id={data.id}
                                                  />
                                                  <div
                                                    onClick={() => handleOpenContentGroupPopUp(data.id)}
                                                    className={`page-content-group-list__content-group-title cursor-pointer ${ isCardVisited(data.id) ? 'text-blue': ''}`}>

                                                    <div className='d-flex align-items-center'>
                                                      <div className="truncate">{data.name}</div>

                                                      <RedDot className={`mx-1 ${ has_unread_comments ? '' : 'd-none' }`}/>

                                                      {
                                                        hasDraft(data?.drafts || []) &&
                                                        <DraftCommentIcon  className={'mx-1'}/>
                                                      }
                                                      
                                                    </div>
                                                
                                                  </div>

                                                  <span
                                                    className="truncate page-content-group-list__content-group-description"
                                                  >
                                                    { data.summary }
                                                  </span>

                                                </div>

                                              </div>
                                            </div>
                                          </div>
                                          {
                                            ((stage.require_approval_from_client && data?.stage?.submitted) ||
                                            (can_access_clone_content_group || can_access_content_destroy))  &&
                                              <div className="text-center">
                                                <div className=' d-flex align-items-center'>
                                                  <ProgressIcon content_group={data}/>

                                                  {
                                                    (can_access_clone_content_group || can_access_content_destroy) &&
                                                    !stage?.enable_timestamp && 
                                                      <ContentGroupSettings
                                                        workspace_id={workspace_id}
                                                        content_group_id={data.id}
                                                        stage_id={data.stage_id}
                                                        can_destroy={can_access_content_destroy}
                                                        can_clone={can_access_clone_content_group}
                                                      />
                                                  }
                                                </div>
                                              </div>
                                          }
                                        </div>
                                      </td>
                                      <td className="pivoted text-center">
                                        <StageLabel
                                          name={ stage_name }
                                          selected_stage_id={stage_id}
                                          can_access_edit_title={ can_access_move_content_list }
                                          stages={ allowed_stages }
                                          scrollable={false}
                                          asDropdown={true}
                                          hoverable={true}
                                          className={'m-auto'}
                                          containerClassName={'m-auto stage-container d-flex flex-column'}
                                          handleInlineEdit={(handleOnBlur, stage_id) => handleInlineEdit(handleOnBlur, stage_id, data.id)}
                                        />
                                      </td>
                                      <td className="pivoted text-center p-0">
                                        { can_access_add_change_date ?
                                            <DateTimeInlineEdit
                                              content_group_date={data.due_date}
                                              type="due_date"
                                              handleInlineEdit={(handleOnBlur, due_date, setIsDisabled) => handleInlineEdit(handleOnBlur, due_date, data.id, setIsDisabled)}
                                              buttonType='text'
                                              asDropdown={true}
                                              hoverable={true}
                                            />
                                          :
                                            ( data.due_date ?
                                                dateTimeFormatter(data.due_date)
                                              :
                                                '-'
                                            )
                                        }
                                      </td>
                                      <td className="pivoted">
                                        <LabelField
                                          can_access_edit_label={can_access_edit_label}
                                          workspace_id={workspace_id}
                                          content_group_id={data.id}
                                          labels={data.labels}
                                          asDropdown={true}
                                          buttonType='text'
                                          hoverable={true}
                                        />
                                      </td>

                                      {can_access_show_content_details &&
                                        <td data-th="Project: " className="pivoted">
                                          <ParticipantField
                                            can_access_assigned_user={can_access_assigned_user}
                                            workspace_id={workspace_id}
                                            assigned_users={data.assigned_users}
                                            content_group_id={data.id}
                                          />
                                        </td>
                                      }
                                      <td className="pivoted text-center p-0 subtask-cell">
                                        <div>
                                          <CardSubtaskStats completed={data?.completed_subtasks} total={data?.total_subtasks} />
                                        </div>
                                         
                                      </td>
                                       <td className="pivoted text-center p-0 timer-cell">
                                          <CardTimerStats 
                                            initialTime={data?.total_timestamp_info?.total_seconds || 0} 
                                            initialStartDate={data?.total_timestamp_info?.latest_start} 
                                          />
                                       </td>
                                       <td className="pivoted text-center p-0 revision-cell">
                                          <CardRevisionCount count={data?.revision_count} />
                                       </td>
                                    </tr>
                                  );
                                }}
                              </Draggable>
                            );
                          })
                          :
                          !can_access_content && !loading &&
                          <tr>
                            <td colSpan="8" className='p-0'>
                              <div className="no_queue_text p-3"> No Queue </div>
                            </td>
                          </tr>
                        }
                        {dropProvided.placeholder}
                        { loading &&
                          <tr>
                            <td colSpan="8">
                              <BasicSpinner />
                            </td>
                          </tr>
                        }

                          { rows?.page < rows?.total_pages && !loading &&
                            <tr>
                              <td colSpan="8" className='p-0 load-more-td'>
                                <Button className="btn-load-more d-block" variant='load-more' onClick={() => loadNextPage(rows)}>Load More</Button>
                              </td>
                            </tr>
                          }
                      </tbody>
                    </table>

                    {AddCardButton()}
                  </div>
                  );
                }}
              </Droppable>
            </div>
          );
        }}
      </Draggable>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    created_content_group: state.content_group.created_content_group,
    destroyed_content_group: state.content_group.destroyed_content_group,
    updated_content_group: state.content_group.updated_content_group,
    currentSearchText: state.search_history.current_search_text,
    can_access_clone_content_group: state.work_space.can_access_clone_content_group,
    can_access_content_destroy: state.work_space.can_access_content_destroy,
    stages_to_reload: state.stage.stages_to_reload
  };
};

export default connect(mapStateToProps, { stageActions })(ContentGroupList);